import { Link } from "react-router-dom";
import { brand } from "@/mocks/site";

const heroImg =
  "https://readdy.ai/api/search-image?query=Warm%20energetic%20abstract%20pop-art%20background%20with%20floating%20glossy%20speech%20bubbles%2C%20chat%20icons%2C%20exclamation%20and%20question%20marks%2C%20flame%20and%20star%20shapes%2C%20scattered%20confetti%2C%20coral%20orange%20red%20pink%20and%20cream%20gradients%2C%20high%20contrast%20playful%20flat%20vector%20illustration%2C%20spacious%20soft%20depth%2C%20vibrant%20yet%20clean%2C%20no%20text&width=1600&height=860&seq=regan-hero-x1&orientation=landscape";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImg} alt="全网热瓜抽象插画背景" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/40 to-foreground-950/70"></div>
      </div>

      <div className="relative mx-auto flex min-h-[520px] w-full max-w-container flex-col items-center justify-center px-4 py-16 text-center md:min-h-[640px] md:px-6">
        <span className="animate-ticker-pop inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-background-50/15 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
          <i className="ri-fire-line text-secondary-300"></i>
          今日实时热榜已更新 · 共 8 条在追
        </span>

        <h1 className="mt-6 max-w-3xl text-balance text-4xl font-semibold leading-tight text-background-50 md:text-5xl">
          全网热瓜，别只吃一半
          <br />
          把同类剧情<span className="text-secondary-300">摆在一起看</span>
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-7 text-background-100/95 md:text-base">
          {brand.name}把系列事件按时间线串联、把同类盘点与对比分析放进同一张桌，
          相似剧情与后续走向，一次给你摸清。冷静吃瓜，拒绝带节奏。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/#series"
            className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-medium text-background-50 transition hover:bg-primary-400"
          >
            开始追系列事件 <i className="ri-arrow-down-line ml-1"></i>
          </Link>
          <Link
            to="/duibi"
            className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-full border border-background-50/60 px-7 text-sm font-medium text-background-50 backdrop-blur transition hover:bg-background-50/15"
          >
            看对比分析
          </Link>
        </div>

        <dl className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { v: "128+", l: "已梳理专题" },
            { v: "46", l: "事件时间线" },
            { v: "32", l: "对比手册" },
            { v: "24h", l: "热点滚动更新" },
          ].map((s) => (
            <div key={s.l} className="rounded-xl border border-background-50/20 bg-background-50/10 px-4 py-4 backdrop-blur">
              <dt className="order-2 mt-1 text-xs text-background-200">{s.l}</dt>
              <dd className="font-display text-2xl text-secondary-300">{s.v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}